import React from 'react'
import LabDrawer from '../../components/drawers/lab'
import BilledQueue from '../../components/pages/billedQueue'

const LabQueue = () => {
    return <BilledQueue category="Lab" basePath="/app/lab/queue" DrawerComponent={LabDrawer} showPendingForwardsBadge />
}

export default LabQueue
